import { render, staticRenderFns } from "./ContentNotAvailable.vue?vue&type=template&id=1e01639a&scoped=true&"
import script from "./ContentNotAvailable.vue?vue&type=script&lang=js&"
export * from "./ContentNotAvailable.vue?vue&type=script&lang=js&"
import style0 from "./ContentNotAvailable.vue?vue&type=style&index=0&id=1e01639a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e01639a",
  null
  
)

export default component.exports